import { render, staticRenderFns } from "./ve-table-subproducts.vue?vue&type=template&id=008e2df1"
import script from "./ve-table-subproducts.vue?vue&type=script&lang=js"
export * from "./ve-table-subproducts.vue?vue&type=script&lang=js"
import style0 from "./ve-table-subproducts.vue?vue&type=style&index=0&id=008e2df1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports